/* eslint-disable react/jsx-props-no-spreading */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { FormattedMessage } from 'react-intl';
import * as AppPropTypes from '../../lib/PropTypes';

import Link from '../partials/Link';
import Html from '../partials/Html';
import LinkButton from '../buttons/LinkButton';
import { useIntersectionObserver } from '../../hooks/useObserver';
import { getImageSize } from '../../lib/utils';

import styles from '../../../styles/items/page-tile.module.scss';

const propTypes = {
    title: PropTypes.string,
    url: PropTypes.string,
    body: PropTypes.string,
    image: AppPropTypes.image,
    color: PropTypes.string,
    cta: PropTypes.node,
    withoutButtonLabel: PropTypes.bool,
    withoutLinks: PropTypes.bool,
    reverse: PropTypes.bool,
    className: PropTypes.string,
};

const defaultProps = {
    title: null,
    url: null,
    body: null,
    color: null,
    image: null,
    cta: null,
    withoutButtonLabel: false,
    withoutLinks: false,
    reverse: false,
    className: null,
};

const PageTile = ({
    title,
    url,
    body,
    color,
    image,
    cta,
    withoutButtonLabel,
    withoutLinks,
    reverse,
    className,
}) => {
    const [hover, setHover] = useState(false);

    const {
        ref,
        entry: { isIntersecting = false },
    } = useIntersectionObserver({ rootMargin: '-15%' });

    const tileValue = hover ? -3 : 0;
    const coverValue = hover ? 2 : 0;

    const label =
        cta !== null ? (
            cta
        ) : (
            <FormattedMessage defaultMessage="Go to section" description="Section link label" />
        );

    const large = getImageSize(image, 'home');
    const { url: imageUrl = null } = large || {};

    return (
        <div
            className={classNames([
                styles.container,
                {
                    [className]: className !== null,
                },
            ])}
            ref={ref}
            style={{
                opacity: `${isIntersecting ? 1 : 0}`,
                // color: elementsColor,
            }}
            onMouseEnter={() => setHover(true)}
            onMouseLeave={() => setHover(false)}
        >
            <Link
                disabled={withoutLinks}
                href={url}
                className={styles.tile}
                style={{
                    backgroundImage: `linear-gradient(to bottom, ${color} 0%, ${color} 100%)`,
                    transform: `translateX(${isIntersecting ? tileValue : -30}px)`,
                }}
            >
                <div
                    className={styles.cover}
                    style={{
                        transform: `translate(${isIntersecting ? coverValue * 2 : 60}px, ${
                            isIntersecting ? coverValue : 60
                        }px)`,
                        backgroundColor: color,
                        filter: `grayscale(90%) contrast(150%)`,
                        opacity: 0.7,
                    }}
                >
                    {imageUrl !== null ? (
                        <div
                            className={classNames([
                                styles.image,
                                {
                                    [styles.reverse]: reverse,
                                },
                            ])}
                            style={{ backgroundImage: `url(${image.url})` }}
                        />
                    ) : null}
                </div>
                <div className={styles.inner} style={{ color }}>
                    {title !== null ? <h2 className={styles.title}>{title}</h2> : null}
                    {body !== null ? <Html className={styles.description} body={body} /> : null}
                    {!withoutLinks ? (
                        <div className={styles.action}>
                            <LinkButton className={styles.button}>
                                {!withoutButtonLabel ? label : null}
                            </LinkButton>
                        </div>
                    ) : (
                        <div className={styles.action} />
                    )}
                </div>
            </Link>
        </div>
    );
};

PageTile.propTypes = propTypes;
PageTile.defaultProps = defaultProps;

export default PageTile;
